import { render, staticRenderFns } from "./PostCreateDialog.vue?vue&type=template&id=5f14afcc&scoped=true"
import script from "./PostCreateDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PostCreateDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PostCreateDialog.vue?vue&type=style&index=0&id=5f14afcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f14afcc",
  null
  
)

export default component.exports